import convert from "color-convert";

const primary = "#00494E"; // Unify Green
const accent = "#9EB38D"; // Deep Green
const lilac = "#D5CFEB";
const darkGreen = "#142929";
const liveGreen = "#C7FFBC"; // reserved for hover

const colors = {
    primary,
    accent,
    lilac,
    darkGreen,
    liveGreen,

    greenLight: "#3CC480",
    green: "#00B692",
    greenDark: "#03856C",

    white: "#FFFFFF",

    grey1: "#F0F2F8",
    grey2: "#D6D6D6",
    grey3: "#C8C8C8",
    grey4: "#707070",
    grey5: "#4D4D4D",

    blueGreen: "#21AEAC",
    blue1: "#BCE0FD",
    blue2: "#A7A7FF",
    bluePrimary: primary, // legacy alias

    red: "#FF4141",

    overview: {
        icons: ["#587DFB", "#A300FF", "#f98f00", "#03856C"],

        backgrounds: ["#CCD8FF", "#EED1FF", "#FFF4CC", "#CEFFE6"],
    },

    charts: {
        line: [primary, lilac, "#f98f00", "#999999", "#b44a13", "#00D27E", "#014133", "#21AEAC", "#2979FF", "#3CC480"],

        doughnut: [primary, lilac, "#f98f00", "#999999", "#b44a13", "#00D27E", "#014133", "#21AEAC", "#2979FF", "#3CC480"],

        bar: [primary],
    },

    vivo: {
        purple: "#660099",
        pink: "#cb2166",
        green: "#01a001",
        blue: "#0066ff",
        yellow: "#EEDD55",
        orange: "#FF5C01",
        lightPurple: "#D1B2E0",

        get charts() {
            return {
                line: [this.purple, this.lightPurple, this.blue, this.green, this.yellow, this.orange],
                doughnut: [this.green, this.purple, this.pink, this.blue, this.yellow, this.orange, this.lightPurple],
                bar: [this.purple],
            };
        },
    },

    abc: {
        get charts() {
            return {
                line: ['#5F1319', '#F7A600'],
                doughnut: ['#5F1319', '#F7A600', '#F9F2D7', '#A35B66', '#EEDD55', '#FFC389', "#2979FF", "#993f7f", "#f98f00", "#999999"],
                bar: ['#5F1319'],
            }
        }
    },

    unifique: {
        get charts() {
            return {
                line: ['#212492', '#F5EC5A'],
                doughnut: ['#212492', '#00A2FF', '#F5EC5A', '#3FCFD5', '#ffd31b', '#E7F0F3', "#2a7155", "#993f7f", "#f98f00", "#999999"],
                bar: ['#212492'],
            }
        }
    },

    vero: {
        get charts() {
            return {
                line: ['#29377F', '#f3953f'],
                doughnut: ['#252B51', '#29377F', '#f3953f', '#344DAE', '#ffd31b', '#D63066', "#2a7155", "#993f7f", "#f98f00", "#999999"],
                bar: ['#29377F'],
            }
        }
    },

    personalize: {
        styleIds: {
            WHITE: "WHITE",
            RED: "RED",
            PINK: "PINK",
            YELLOW: "YELLOW",
            BLACK: "BLACK",
            BLUE: "BLUE",
            PURPLE: "PURPLE",
            GREEN: "GREEN",
            GRAY: "GRAY",
        },
        predefinedStyles: [
            {
                id: "WHITE",
                preview: "#fff",
                bg: "#fff",
                button: {
                    bg: "#2a7155",
                    color: "#fff",
                },
                text: "#1F1F1F",
            },
            {
                id: "RED",
                preview: "#C70000",
                bg: "linear-gradient(0deg, #680000, #C70000)",
                button: {
                    bg: "#fff",
                    color: "#1F1F1F",
                },
                text: "#fff",
            },
            {
                id: "ORANGE",
                preview: "#E55C00",
                bg: "linear-gradient(0deg, #BF4D00, #E55C00)",
                button: {
                    bg: "#fff",
                    color: "#1F1F1F",
                },
                text: "#fff",
            },
            {
                id: "PINK",
                preview: "#FF7A6E",
                bg: "linear-gradient(0deg, #DE655B, #FF7A6E)",
                button: {
                    bg: "#fff",
                    color: "#1F1F1F",
                },
                text: "#fff",
            },
            {
                id: "YELLOW",
                preview: "#FBDE00",
                bg: "linear-gradient(0deg, #E6B100, #FBDE00)",
                button: {
                    bg: "#fff",
                    color: "#1F1F1F",
                },
                text: "#1F1F1F",
            },
            {
                id: "BLACK",
                preview: "#272727",
                bg: "linear-gradient(0deg, #000, #272727)",
                button: {
                    bg: "#fff",
                    color: "#1F1F1F",
                },
                text: "#FFF",
            },
            {
                id: "BLUE",
                preview: "#003F80",
                bg: "linear-gradient(0deg, #002650, #003F80)",
                button: {
                    bg: "#fff",
                    color: "#1F1F1F",
                },
                text: "#FFF",
            },
            {
                id: "PURPLE",
                preview: "#52307C",
                bg: "linear-gradient(0deg, #29183E, #52307C)",
                button: {
                    bg: "#fff",
                    color: "#1F1F1F",
                },
                text: "#FFF",
            },
            {
                id: "GREEN",
                preview: "#497461",
                bg: "linear-gradient(0deg, #092f39, #497461)",
                button: {
                    bg: "#fff",
                    color: "#1F1F1F",
                },
                text: "#fff",
            },
            {
                id: "GRAY",
                preview: "#707070",
                bg: "linear-gradient(0deg, #383838, #707070)",
                button: {
                    bg: "#FFF",
                    color: "#1F1F1F",
                },
                text: "#fff",
            },
        ],
    },
};

export default {
    ...colors,

    ...convert,

    hex: {
        rgba(color, opacity) {
            const rgb = convert.hex.rgb(color);

            return `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${opacity})`;
        },
    },
};
